import { render, staticRenderFns } from "./NsSpinner.vue?vue&type=template&id=3f2f73fc&"
import script from "./NsSpinner.vue?vue&type=script&lang=js&"
export * from "./NsSpinner.vue?vue&type=script&lang=js&"
import style0 from "./NsSpinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2f73fc')) {
      api.createRecord('3f2f73fc', component.options)
    } else {
      api.reload('3f2f73fc', component.options)
    }
    module.hot.accept("./NsSpinner.vue?vue&type=template&id=3f2f73fc&", function () {
      api.rerender('3f2f73fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsSpinner.vue"
export default component.exports